// Providing a functions that can manipulate Yodiwo global variable
// window.Yodiwo = {xxxx}



// Link local variable with global one
var YodiwoGlobal = {};
(window as any).Yodiwo = YodiwoGlobal;


// Build time parameters
declare var __IN_DEBUG__: boolean;
declare var __VERSION__: string;
declare var __GIT_VERSION__: string;
declare var __TIMESTAMP__: string;

YodiwoGlobal["__IN_DEBUG__"] = __IN_DEBUG__;
YodiwoGlobal["__VERSION__"] = __VERSION__;
YodiwoGlobal["__GIT_VERSION__"] = __GIT_VERSION__;
YodiwoGlobal["__TIMESTAMP__"] = __TIMESTAMP__;
YodiwoGlobal["AnimationEnabled"] = false;
YodiwoGlobal["GemProfileMarking"] = false;

// ------------------------------------------------------
export function setGlobal(name: string, value: any) {
    YodiwoGlobal[name] = value;
}
// ------------------------------------------------------
export function getGlobal(name: string): any {
    return YodiwoGlobal[name];
}
// ------------------------------------------------------
export function isAnimationEnabled(): boolean {
    return YodiwoGlobal["AnimationEnabled"];
}
// ------------------------------------------------------